export const isEmpty = (mixedVar: object | string | number | undefined | null): boolean => {
    let key
    const emptyValues = [undefined, null, false, 0, '', '0', {}]

    if (emptyValues.includes(mixedVar)) {
        return true
    }

    if (typeof mixedVar === 'object') {
        for (key in mixedVar) {
            if (mixedVar?.hasOwnProperty(key)) {
                return false
            }
        }
        return true
    }

    return false
}
